import { render, staticRenderFns } from "./TopicDetailsView.vue?vue&type=template&id=00cb089b&"
import script from "./TopicDetailsView.vue?vue&type=script&lang=js&"
export * from "./TopicDetailsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports